export function markTFNInfoTables(html) {
  if (!html) return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  return doc.body.innerHTML;
}

